import { getRouteApi } from '@tanstack/react-router';

import { Modal } from 'src/components';

import { CancelConnectConfirm } from './CancelConnectConfirm';
import { CancelConnectSurvey } from './CancelConnectSurvey';

const routeApi = getRouteApi('/_auth/_layout/subscriptions/plan');

export const CancelConnectModal = ({
  isCancelling,
  cancelError,
  onCancel,
}: {
  isCancelling: boolean;
  cancelError: Error | null;
  // Starts the caller-specific cancellation mutation and invokes the callback after it succeeds.
  // StoreAPI and Cloud Connect use different cancellation mutations but share this modal.
  onCancel: (onSuccess: () => void) => void;
}) => {
  return (
    <Modal.Content className="flex h-full max-h-[700px] max-w-l2xl flex-col justify-between ls:pb-16">
      <ModalRouter
        isCancelling={isCancelling}
        cancelError={cancelError}
        onCancel={onCancel}
      />
    </Modal.Content>
  );
};

const ModalRouter = ({
  isCancelling,
  cancelError,
  onCancel,
}: {
  isCancelling: boolean;
  cancelError: Error | null;
  onCancel: (onSuccess: () => void) => void;
}) => {
  const search = routeApi.useSearch();
  switch (search.cancel_subscription) {
    case 'confirm':
      return (
        <CancelConnectConfirm
          isCancelling={isCancelling}
          cancelError={cancelError}
          onCancel={onCancel}
        />
      );
    case 'survey':
      return <CancelConnectSurvey />;
    default:
      return null;
  }
};
